import { FC, SVGAttributes } from 'react';

const TransactionArrowDown: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.0234 22V7"
                stroke="#282828"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.049 15.9492L15.025 21.9992L9 15.9492"
                stroke="#282828"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default TransactionArrowDown;
